import { injectIntl, IntlShape } from 'react-intl';

import { translate } from 'containers/services/translate';
import emptyBox from 'images/emptyBox.svg';
import { isEmpty } from 'lodash';
import messages from 'containers/CourtManagerLegalProceedings/Provision/Regulation/messages';
import {
  RecapContainer,
  RegulationRecapContainer,
  RiskContainer,
  Title,
} from 'containers/CourtManagerLegalProceedings/Provision/Regulation/styled-components';
import { Listings } from 'containers/AppContainer/typings';
import SideRegulationDetails from 'containers/CourtManagerLegalProceedings/Provision/Regulation/SideRecap/SideRegulationDetails';
import { ClaimRecapType } from 'typings/claimTypes';

export interface SideRegulationRecapProps {
  intl: IntlShape;
  sagisClaim: any;
  claimRecap: ClaimRecapType;
  riskRecap: any;
  listings: Listings;
  substituteDocumentNature: any;
  showRegulationJudgement: boolean;
  height: number;
  isBasicManagementRegulation?: boolean;
}

export const SideRegulationRecap: React.FC<SideRegulationRecapProps> = ({
  sagisClaim,
  claimRecap,
  riskRecap,
  listings,
  substituteDocumentNature,
  showRegulationJudgement,
  height,
  ...props
}): JSX.Element => {
  return (
    <RegulationRecapContainer height={height}>
      <Title className="recap-title">
        {translate(messages.regulationRecapTitle, props)}
      </Title>
      <RiskContainer>
        <RecapContainer>
          {isEmpty(riskRecap) ? (
            <div className="no-data">
              <img src={emptyBox} alt="empty box" />
              <span style={{ display: 'block' }} className="title">
                {translate(messages.noDataTitle, props)}
              </span>
            </div>
          ) : (
            <div className="side-recap">
              {riskRecap.map((risk: any) => (
                <SideRegulationDetails
                  key={risk.regulationId}
                  height={height}
                  sagisClaim={sagisClaim}
                  claimRecap={claimRecap}
                  riskRecap={riskRecap}
                  substituteDocumentNature={substituteDocumentNature}
                  listings={listings}
                  showRegulationJudgement={showRegulationJudgement}
                  risk={risk}
                  isBasicManagementRegulation={
                    props.isBasicManagementRegulation
                  }
                />
              ))}
            </div>
          )}
        </RecapContainer>
      </RiskContainer>
    </RegulationRecapContainer>
  );
};

export default injectIntl(SideRegulationRecap);
